import { getCountryName } from '@monoimin/utils/formatters';

import {
  metaTitlesForPropertyTypeDict,
  replaceTemplate,
  RealEstateDict,
} from '@monoimin/intl';

import { OBJECT_TYPE_PAGE_SLUG_CONFIGS } from '../../configs/page-slug-configs';

import { formatCountryName } from '../formatCountryName';

import type { EnOrRuLocale } from '@monoimin/sb-types';
import type { PageMetaTitles } from '../../types';

const completeCountryNames: {
  [key: string]: string | undefined;
} = {
  'St. Lucia': 'St Lucia',
};

const completeObjectTypeTitlesForMeta: {
  [key: string]: string | undefined;
} = {
  Houses: 'Houses and Homes',
  houses: 'houses and homes',
  'Hotel complexes': 'Hotel Complexes',
  'Residential complexes': 'Residential Complexes',
  'Yacht berths': 'Yacht Berths',
};

export const defineMetaTitlesForPropertyType = <
  T extends { title: string; slug: string }
>(
  objectType: T,
  countryCode: string | undefined,
  locale: EnOrRuLocale,
  project: string,
  realEstateDict: RealEstateDict
): PageMetaTitles => {
  const typeTitle = objectType.title;

  const countryName = getCountryName(countryCode, locale);

  // Склоняем название страны в дательный падеж
  const formattedCountryName = String(formatCountryName(countryName, locale));

  const pageSlugConfig = OBJECT_TYPE_PAGE_SLUG_CONFIGS.find((item) => {
    return item.slug === objectType.slug;
  });

  if (!pageSlugConfig) {
    return {
      title: '',
      description: '',
    };
  }

  const titleInGenetiveCase =
    realEstateDict.objectTypesInGenetiveCase[pageSlugConfig.dictKey];

  const withCountryOrDefault = countryName ? 'withCountry' : 'default';

  const metaTitles =
    metaTitlesForPropertyTypeDict[locale][withCountryOrDefault];

  const replacers = {
    countryName:
      completeCountryNames[formattedCountryName] || formattedCountryName,
    project: project,
    typeTitle: completeObjectTypeTitlesForMeta[typeTitle] || typeTitle,
    typeDescription:
      completeObjectTypeTitlesForMeta[titleInGenetiveCase] ||
      titleInGenetiveCase,
  };

  return {
    title: replaceTemplate(metaTitles.title, replacers),
    description: replaceTemplate(metaTitles.description, replacers),
  };
};

export default defineMetaTitlesForPropertyType;
